import api from "./api";

export const createDriver = async (payload) =>
    (await api.post("/driver", payload)).data;

export const getDrivers = async () =>
    (await api.get("/driver")).data;

export const getDriverById = async (id) =>
    (await api.get(`/driver/${id}`)).data;

export const updateDriver = async (id, payload) =>
    (await api.put(`/driver/${id}`, payload)).data;

export const deleteDriver = async (id) =>
    (await api.delete(`/driver/${id}`)).data;

export const assignShipmentToDriver = async (driverId, payload) =>
    (
        await api.post(
            `/driver/${driverId}/assign-shipment`,
            payload
        )
    ).data;

export const getDriverAssignments = async (driverId) =>
    (
        await api.get(
            `/driver/${driverId}/assignments`
        )
    ).data;

/* ===== AI ===== */

export const getDriverDashboard = async () =>
    (
        await api.get("/driver/dashboard")
    ).data;

export const getDriverStatistics = async () =>
    (
        await api.get("/driver/statistics")
    ).data;

export const getDriverPerformance = async (driverId) =>
    (
        await api.get(`/driver/${driverId}/performance`)
    ).data;

export const getDriverLocation = async (driverId) =>
    (
        await api.get(`/driver/${driverId}/location`)
    ).data;

export default {
    createDriver,
    getDrivers,
    getDriverById,
    updateDriver,
    deleteDriver,
    assignShipmentToDriver,
    getDriverAssignments,
    getDriverDashboard,
    getDriverStatistics,
    getDriverPerformance,
    getDriverLocation,
};